export default __webpack_public_path__ + "static/program_2-a83a413d38ee8eb4aad18fe687904759.png";